import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=830f8678&scoped=true&"
import script from "./MultipleChoice.vue?vue&type=script&lang=js&"
export * from "./MultipleChoice.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoice.vue?vue&type=style&index=0&id=830f8678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830f8678",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('830f8678')) {
      api.createRecord('830f8678', component.options)
    } else {
      api.reload('830f8678', component.options)
    }
    module.hot.accept("./MultipleChoice.vue?vue&type=template&id=830f8678&scoped=true&", function () {
      api.rerender('830f8678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/components/inputs/MultipleChoice.vue"
export default component.exports